export default __webpack_public_path__ + "/dist/images/logo-blue.50ee37b5b83c489fa0081bed0dad785a.svg";